module.exports = __webpack_public_path__ + "images/ODOExample.1268512ab7d30c2fcd8237e30b32106c.png";